
import { AxiosTeenus } from './axios-teenus';
import { Dokument } from '@/models/Dokument';

export class DokumendidTeenus {

    public async minuAmetnikuLisatudDokumendid(): Promise<Dokument[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<Dokument[]>(`/api/dokumendid/ametniku-lisatud-dokumendid`);

        return response?.data;
    }

    public async minuKirjalikudHoiatused(): Promise<Dokument[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<Dokument[]>(`/api/dokumendid/kirjalikud-hoiatused`);

        return response?.data;
    }

    public async minuErakorralisedEttekanned(): Promise<Dokument[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<Dokument[]>(`/api/dokumendid/erakorralised-ettekanned`);

        return response?.data;
    }

    public async laadiAmetnikuDokumentAlla(failiId: number): Promise<Blob> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<Blob>(`/api/dokumendid/ametniku-lisatud-dokument/${failiId}`, {responseType: 'blob'});

        return response?.data;
    }

    public async laadiHoiatuseDokumentAlla(failiId: number): Promise<Blob> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<Blob>(`/api/dokumendid/hoiatuse-dokument/${failiId}`, {responseType: 'blob'});

        return response?.data;
    }

    public async laadiEttekandeDokumentAlla(failiId: number): Promise<Blob> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<Blob>(`/api/dokumendid/ettekande-dokument/${failiId}`, {responseType: 'blob'});

        return response?.data;
    }
}